import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import logo from "../../../resources/img/smileweb.png";

function Inicio() {
    const history = useHistory();

    useEffect(() => {
        // Verificar si el usuario está autenticado
        const userdata = localStorage.getItem('userdata');
        if (!userdata) {
            // Si no está autenticado, redirigir al login
            history.push('/login');
            return;
        }

        try {
            const userData = JSON.parse(userdata);
            if (!userData || !userData.access_token) {
                history.push('/login');
            }
        } catch (error) {
            console.log('Error parsing userdata:', error);
            history.push('/login');
        }
    }, [history]);

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #323a45 0%, #3991b7 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            <div style={{
                background: 'white',
                borderRadius: '20px',
                padding: '60px 40px',
                maxWidth: '600px',
                width: '100%',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                textAlign: 'center'
            }}>
                <div style={{
                    width: '140px',
                    height: '140px',
                    background: 'linear-gradient(135deg, #323a45 0%, #3991b7 100%)',
                    borderRadius: '20px',
                    margin: '0 auto 30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    boxShadow: '0 10px 30px rgba(57, 145, 183, 0.3)'
                }}>
                    <img 
                        src={logo} 
                        alt="SmileWEB Logo" 
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }}
                    />
                </div>
                <h1 style={{
                    fontSize: '32px',
                    fontWeight: '700',
                    color: '#2d3748',
                    marginBottom: '15px',
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                }}>
                    ¡Bienvenido a SmileWEB!
                </h1>
                <p style={{
                    fontSize: '18px',
                    color: '#718096',
                    marginBottom: '30px',
                    lineHeight: '1.6'
                }}>
                    Sistema Integral de Gestión Médica y Odontológica
                </p>
                <div style={{
                    background: '#f7fafc',
                    borderRadius: '12px',
                    padding: '25px',
                    marginBottom: '30px'
                }}>
                    <p style={{
                        fontSize: '16px',
                        color: '#4a5568',
                        margin: '0',
                        lineHeight: '1.8'
                    }}>
                        Utiliza el menú lateral para acceder a las diferentes funcionalidades del sistema: gestión de pacientes, agenda médica, facturación electrónica, historias clínicas y más.
                    </p>
                </div>
                <button
                    onClick={() => history.push('/home')}
                    style={{
                        background: 'linear-gradient(135deg, #323a45 0%, #3991b7 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '15px 40px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(57, 145, 183, 0.4)',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                    }}
                    onMouseOver={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(57, 145, 183, 0.5)';
                    }}
                    onMouseOut={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 15px rgba(57, 145, 183, 0.4)';
                    }}
                >
                    Ir al Inicio
                </button>
            </div>
        </div>
    );
}

export default Inicio;